import * as React from 'react'
import { ExportInvoiceButton } from './ExportInvoiceButton'
import { inject } from 'mobx-react'
import { CreateInvoiceList } from '../..'
import { Filter } from '../../FilterStore'
import { Routes } from '../../../../../constants/Routes'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { BlazeButton } from '../../../../../components/CustomButtons/BlazeButton'
import { HelpLinkMenu } from '../../../../../components/GrDropdown/HelpLinkMenu/HelpLinkMenu'
import { browserHistory } from 'react-router'
import { HelpLinks } from '../../../../../constants/ExternalLinks'

interface Props {
  createInvoiceList: CreateInvoiceList
  invoiceFilter: Filter
}

interface InjectedProps {
  currentCompanyStore?: CurrentCompanyStore
}

export const InvoiceHeader = inject('currentCompanyStore')((props: Props & InjectedProps) => {
  const { createInvoiceList, invoiceFilter } = props
  const companyId = props.currentCompanyStore!.company!.id
  const widthBreakPoint = 650

  return (
    <span className='spaced-button-wrapper'>
      <HelpLinkMenu
        helpLinkMenus={[
          {
            href: HelpLinks.PURCHASE_ORDERS,
            title: 'Adding a purchase order',
          },
          {
            href: HelpLinks.PURCHASE_ORDERS_IMPORT_OPTIONS,
            title: 'Provincial imports',
          },
          {
            href: HelpLinks.WHOLESALE_COST,
            title: 'Understanding wholesale costs',
          },
        ]}
      />

      <ExportInvoiceButton
        createInvoiceList={createInvoiceList}
        invoiceFilter={invoiceFilter}
        widthBreakPoint={widthBreakPoint}
      />

      <BlazeButton
        buttonProps={{
          type: 'primary',
          icon: 'plus',
          onClick: () => {
            browserHistory.push(Routes.ADD_INVOICE(companyId, window.location.search))
          },
        }}
        titleProps={{
          title: 'Add purchase order',
          widthBreakPoint,
        }}
      />
    </span>
  )
})
